import React from 'react';
import { Form, Message } from 'semantic-ui-react';
import { canUseOpenCodeProfileV95 } from './outboundProfileV95';

export default function OutboundClientProfileV95({
  type,
  groups,
  config,
  onChange,
  t,
}) {
  const profile = config.outbound_client_profile_v95 || '';
  if (![1, 50].includes(Number(type)) && !profile) return null;
  const supported = canUseOpenCodeProfileV95(type, groups, config);
  const prefix = 'outbound_profile_v95';
  const label = t(`${prefix}.label`);
  return (
    <Form.Field className='outbound-client-profile-v95'>
      <label>{label}</label>
      <Form.Dropdown
        selection
        fluid
        aria-label={label}
        placeholder={t(`${prefix}.default`)}
        name='outbound_client_profile_v95'
        value={profile}
        onChange={onChange}
        options={[
          { key: 'default', value: '', text: t(`${prefix}.default`) },
          {
            key: 'passthrough',
            value: 'opencode_passthrough',
            text: t(`${prefix}.passthrough`),
            disabled: !supported,
          },
          {
            key: 'compatible',
            value: 'opencode_compatible',
            text: t(`${prefix}.compatible`),
            disabled: !supported,
          },
        ]}
      />
      {!supported && profile && (
        <Message
          visible
          warning
          size='small'
          content={t(`${prefix}.conflict`)}
        />
      )}
      {profile && (
        <Message
          visible
          warning
          size='small'
          content={t(`${prefix}.data_notice`)}
        />
      )}
    </Form.Field>
  );
}
